import { render } from "./PeriodoActivoMultiselect.vue?vue&type=template&id=fc7f64aa"
import script from "./PeriodoActivoMultiselect.vue?vue&type=script&lang=js"
export * from "./PeriodoActivoMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__